/**
 * Format reset time for usage limit display
 * @param {number} resetAt - Unix timestamp (seconds)
 * @returns {string} Formatted time string
 *
 * Examples:
 * - Same day: "14:30 hôm nay"
 * - Tomorrow: "09:00 ngày mai"
 * - Later: "10:30 05/11"
 */
export function formatResetTime(resetAt) {
  const resetDate = new Date(resetAt * 1000);
  const now = new Date();

  // Format time as HH:mm
  const hours = resetDate.getHours().toString().padStart(2, '0');
  const minutes = resetDate.getMinutes().toString().padStart(2, '0');
  const timeStr = `${hours}:${minutes}`;

  // Check if today
  if (resetDate.toDateString() === now.toDateString()) {
    return `${timeStr} hôm nay`;
  }

  // Check if tomorrow
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (resetDate.toDateString() === tomorrow.toDateString()) {
    return `${timeStr} ngày mai`;
  }

  // Format as HH:mm DD/MM for later dates
  const day = resetDate.getDate().toString().padStart(2, '0');
  const month = (resetDate.getMonth() + 1).toString().padStart(2, '0');
  return `${timeStr} ${day}/${month}`;
}
